import { Theme } from '@mui/material/styles';

export default function OverridesPaper(theme: Theme) {
  return {
    MuiPaper: {
      styleOverrides: {
        root: {},
      },
    },
  };
}
